export const events = {
  add: {
    experience: 'ADVISER_WORK_EXPERIENCE_ADD_NEW_EXPERIENCE'
  },
  edit: {
    start: 'ADVISER_WORK_EXPERIENCE_START_EDITING',
    stop: 'ADVISER_WORK_EXPERIENCE_STOP_EDITING',
    cancel: 'ADVISER_WORK_EXPERIENCE_CANCEL_EDITING'
  },
  set: {
    experience: 'ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE',
    startMonth: 'ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_MONTH',
    endMonth: 'ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_MONTH',
    startYear: 'ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_YEAR',
    endYear: 'ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_YEAR',
    endDateCurrent: 'ADVISER_WORK_EXPERIENCE_SET_END_DATE_CURRENT'
  },
  deletes: {
    experience: 'ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE',
    modal: 'ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE_MODAL',
    cancel: 'ADVISER_WORK_EXPERIENCE_CANCEL_DELETING_EXPERIENCE'
  }
}

const {add, edit, set, deletes} = events

export const actions = {
  add: {
    experience: () => ({
      type: add.experience,
      experience: {
        position: null,
        company: null,
        isCurrentJob: false,
        positionStartDate: null,
        positionEndDate: null
      }
    })
  },
  edit: {
    start: index => ({
      type: edit.start,
      index
    }),
    stop: () => ({
      type: edit.stop
    }),
    cancel: () => ({
      type: edit.cancel
    })
  },
  set: {
    experience: (validationResult, experience) => ({
      type: set.experience,
      experience,
      validationResult
    }),
    startMonth: (validationResult, month) => ({
      type: set.startMonth,
      month,
      validationResult
    }),
    startYear: (validationResult, year) => ({
      type: set.startYear,
      year,
      validationResult
    }),
    endMonth: (validationResult, month) => ({
      type: set.endMonth,
      month,
      validationResult
    }),
    endYear: (validationResult, year) => ({
      type: set.endYear,
      year,
      validationResult
    }),
    endDateCurrent: () => ({
      type: set.endDateCurrent
    })
  },
  deletes: {
    modal: index => ({
      type: deletes.modal,
      index
    }),
    experience: () => ({
      type: deletes.experience
    }),
    cancel: () => ({
      type: deletes.cancel
    })
  }
}
